import React from "react";

const ForumAreaIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="43.256"
      height="46.838"
      viewBox="0 0 51.001 54.727"
    >
      <g id="db82" transform="translate(-166.634 -151.046)">
        <path
          id="Path_1758"
          data-name="Path 1758"
          d="M206.24,351.5a6.286,6.286,0,1,1-6.286-6.286,6.286,6.286,0,0,1,6.286,6.286"
          transform="translate(-23.742 -170.529)"
          fill={fill ? fill : "#a07eff"}
        />
        <path
          id="Path_1759"
          data-name="Path 1759"
          d="M178.577,462.19h-4.671a6.716,6.716,0,0,0-6.632,5.882l-.635,5.421a1.35,1.35,0,0,0,1.038,1.5,40.8,40.8,0,0,0,8.535.865c1.211,0,2.422-.058,3.576-.173l.577-4.844a9.352,9.352,0,0,1,3.4-6.17,6.713,6.713,0,0,0-5.19-2.48Z"
          transform="translate(0 -273.256)"
          fill={fill ? fill : "#a07eff"}
        />
        <path
          id="Path_1760"
          data-name="Path 1760"
          d="M467.66,351.5a6.286,6.286,0,1,1-6.286-6.286,6.286,6.286,0,0,1,6.286,6.286"
          transform="translate(-253.329 -170.529)"
          fill={fill ? fill : "#a07eff"}
        />
        <path
          id="Path_1761"
          data-name="Path 1761"
          d="M461.162,468.077a6.673,6.673,0,0,0-6.632-5.882h-4.671a6.587,6.587,0,0,0-5.19,2.537,9.352,9.352,0,0,1,3.4,6.17l.577,4.844c1.153.115,2.365.173,3.576.173a40.771,40.771,0,0,0,8.535-.865,1.335,1.335,0,0,0,1.038-1.5Z"
          transform="translate(-244.178 -273.261)"
          fill={fill ? fill : "#a07eff"}
        />
        <path
          id="Path_1762"
          data-name="Path 1762"
          d="M309.232,488.24h-4.613a6.673,6.673,0,0,0-6.632,5.882l-.635,5.421a1.35,1.35,0,0,0,1.038,1.5,42.527,42.527,0,0,0,17.07,0,1.335,1.335,0,0,0,1.038-1.5l-.635-5.421A6.673,6.673,0,0,0,309.232,488.24Z"
          transform="translate(-114.795 -296.134)"
          fill={fill ? fill : "#a07eff"}
        />
        <path
          id="Path_1763"
          data-name="Path 1763"
          d="M336.953,377.555a6.286,6.286,0,1,1-6.286-6.286,6.286,6.286,0,0,1,6.286,6.286"
          transform="translate(-138.539 -193.407)"
          fill={fill ? fill : "#a07eff"}
        />
        <path
          id="Path_1764"
          data-name="Path 1764"
          d="M266.815,168.462H273.1l2.365,4.671a2.24,2.24,0,0,0,3.979,0l2.365-4.671h6.286a3.077,3.077,0,0,0,3.057-3.057V154.1a3.077,3.077,0,0,0-3.057-3.057H266.815a3.077,3.077,0,0,0-3.057,3.057v11.245a3.089,3.089,0,0,0,3.057,3.114Zm17.82-10.957a2.191,2.191,0,1,1-2.191,2.191A2.19,2.19,0,0,1,284.634,157.505Zm-7.209,0a2.191,2.191,0,1,1-2.191,2.191A2.19,2.19,0,0,1,277.426,157.505Zm-7.208,0a2.191,2.191,0,1,1-2.191,2.191A2.19,2.19,0,0,1,270.218,157.505Z"
          transform="translate(-85.297)"
          fill={fill ? fill : "#a07eff"}
        />
      </g>
    </svg>
  );
};

export default ForumAreaIcon;
